import { Crosshair, ShoppingBag } from "lucide-react";

export default function TacticalHeader({ cartCount, onCart }) {
  return (
    <header className="site-header" data-testid="site-header">
      <a className="brand-lockup" href="#top" data-testid="brand-home-link">
        <span className="brand-mark"><Crosshair size={17} strokeWidth={1.5} /></span>
        <span className="brand-name">TECH <b>VAULT</b></span>
        <span className="brand-code">TV//01</span>
      </a>
      <div className="header-nav" aria-label="Primary navigation">
        <a href="#armory" data-testid="armory-nav-link">ARMORY</a>
        <a href="#field-notes" data-testid="field-notes-nav-link">FIELD NOTES</a>
        <a href="#pledge" data-testid="pledge-nav-link">0.10% PLEDGE</a>
      </div>
      <div className="header-status"><span className="status-dot" />SYSTEMS LIVE / $48,290.45 PLEDGED</div>
      <button className="cart-trigger" onClick={onCart} data-testid="cart-drawer-trigger" aria-label="Open armory cart">
        <ShoppingBag size={17} strokeWidth={1.5} />
        <span>ARMORY</span>
        <strong data-testid="cart-count">[{String(cartCount).padStart(2, "0")}]</strong>
      </button>
    </header>
  );
}
